import React from 'react';
import { CalendarOccurrence } from '@/components/organisms/EventCalendar/types';
import './CalendarEventItem.scss';

interface CalendarEventItemProps {
  occurrence: CalendarOccurrence;
  onSelect: (eventId: number) => void;
  formatTime: (value: string) => string;
}

const CalendarEventItem: React.FC<CalendarEventItemProps> = ({ occurrence, onSelect, formatTime }) => {
  return (
    <button
      className="events-calendar-page__event"
      onClick={() => onSelect(occurrence.event.id)}
      type="button"
    >
      <span className="events-calendar-page__event-time">
        {formatTime(occurrence.start_date)}
      </span>
      <span className="events-calendar-page__event-title">
        {occurrence.event.name}
      </span>
    </button>
  );
};

export default CalendarEventItem;
